import { compose, hoistStatics, withState, withHandlers } from 'recompose';
import { translate } from 'react-i18next';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from '../../reducers/user';
import { authActions } from '../../reducers/auth';
import { permissionsActions } from '../../reducers/permissions';
import * as wsOperations from '../../reducers/websockets/operations';

import PhoneCode from './PhoneCode';
import fh from '../../helpers/form.helper';
import AuthService from '../../services/auth.service';

const mapStateToProps = state => ({
  loginColor: state.settings.subscriber.login_color,
  canRegister: !!state.settings.subscriber.can_register,
  loginLayout: state.settings.subscriber.login_layout || 1,
  socialLoginLayout: state.settings.subscriber ? state.settings.subscriber.login_modules_theme : 1,
});

const auth = async (props, token, user, permissions) => {
  const {
    setUser,
    setPermissions,
    setToken,
    connectSocketToServer,
    subscribeToChannel,
  } = props;
  await AuthService.setToken(token);
  await setUser({ user });
  await setPermissions(permissions);
  await setToken({ token });
  connectSocketToServer();
  subscribeToChannel('common');
};

const mapDispatchToProps = {
  setUser: userActions.setUser,
  setToken: authActions.setToken,
  setPermissions: permissionsActions.setPermissions,
  connectSocketToServer: wsOperations.connectSocketToServer,
  subscribeToChannel: wsOperations.subscribeToChannel,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withState('code', 'setCode', ''),
  withState('errors', 'setErrors', {}),
  withState('isSubmitting', 'setIsSubmitting', false),
  withHandlers({
    onSubmit: props => async (event) => {
      event.preventDefault();
      const id = props.match.params.id;
      if (props.code && id > 0) {
        props.setIsSubmitting(true);
        const { token, user, permissions } = await AuthService.checkPhoneCode(id, props.code);
        props.setIsSubmitting(false);
        if (!user) {
          toast.error(props.t('Your code is invalid or expired'));
          props.history.push('/login');
        } else {
          props.setErrors({});
          props.setCode('');
          await auth(props, token, user, permissions);
        }
      }
    },
    onChange: fh.onChange,
  }),
);

export default withRouter(hoistStatics(enhance)(PhoneCode));



// WEBPACK FOOTER //
// ./src/views/phoneCode/index.js